import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class Projects {
  $block: JQuery<HTMLElement>;
  $projects: JQuery<HTMLElement>;
  projects: JQuery<Swiper | null> | null;

  constructor() {
    this.$block = $('.projects');
    this.$projects = this.$block.find('.project');
    this.projects = null;

    this.init();
  }

  init() {
    if (!this.$block.length) return;

    this.projects = this.$projects.map((i, p) => {
      const $project = $(p);
      const $swiper = $project.find('.swiper');
      const $slides = $project.find('.swiper-slide');
      const $pagination = $project.find('.swiper-pagination');
      const $prev = $project.find('.project__prev');
      const $next = $project.find('.project__next');

      if ($slides.length === 1) return null;

      return new Swiper($swiper[0], {
        modules: [Pagination, Navigation],
        navigation: {
          nextEl: $next[0],
          prevEl: $prev[0],
        },
        loop: true,
        pagination: {
          el: $pagination[0],
          clickable: true,
        },
        speed: 700,
      });
    });
  }
}

export default Projects;
